import { Divider, FormControl, TextField } from '@mui/material';
import SelectElement from 'components/SelectElement';
import { getVehiclesSelector } from 'features/Vehicles';
import { shallowEqual, useSelector } from 'react-redux';
import IntlMessages from 'util/IntlMessages';

const ManualFields = ({ selectedVehicle, setSelectedVehicle, odometerValue, setOdometerValue }) => {
  const availableVehicles = useSelector((state) => getVehiclesSelector(state), shallowEqual);

  return (
    <>
      <Divider className="my-3" />
      <h4 className="mb-3">
        <IntlMessages id="components.connector-details.manual-fields-title" />
      </h4>
      <SelectElement
        className="mb-3 align-items-center justify-content-between"
        selectedId={selectedVehicle ? selectedVehicle.number_plate : ''}
        idAttribute="number_plate"
        optionLabel="number_plate"
        label={<IntlMessages id="components.vehicle-details.vehicle" />}
        options={Object.values(availableVehicles)}
        onChange={(selectedVehicle) =>
          setSelectedVehicle(
            Object.values(availableVehicles).find(
              (vehicle) => vehicle.number_plate === selectedVehicle
            )
          )
        }
        defaultValue={<IntlMessages id="common.labels.select-vehicle" />}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      />
      <div className="select-element-container d-flex flex-row mb-3 align-items-center justify-content-between">
        <span className="subtitle mr-2 w-75">
          <IntlMessages id="components.connector-details.manual-fields.vehicle-odometer" />
        </span>
        <FormControl className="connector-select-form">
          <TextField
            required
            label="Odometer value"
            type="number"
            value={odometerValue}
            size="small"
            className="text-center hide-label"
            variant="outlined"
            onChange={(event) => setOdometerValue(event.target.value)}
            InputLabelProps={{
              shrink: false,
            }}
            hiddenLabel={true}
            helperText={
              <span>
                <IntlMessages id="components.connector-details.manual-fields.last-vehicle-odometer" />
                :
                {` ${
                  selectedVehicle &&
                  selectedVehicle.latest_transaction &&
                  selectedVehicle.latest_transaction.odometer
                    ? `${parseFloat(selectedVehicle.latest_transaction.odometer) / 1000} km`
                    : '- - -'
                }`}
              </span>
            }
          />
        </FormControl>
      </div>
      {selectedVehicle &&
      selectedVehicle.latest_transaction &&
      selectedVehicle.latest_transaction.odometer &&
      odometerValue &&
      parseFloat(odometerValue) < parseFloat(selectedVehicle.latest_transaction.odometer) / 1000 ? (
        <span className="text-warning font-size-12">
          <IntlMessages id="components.connector-details.manual-fields-odometer-warning" />
        </span>
      ) : null}
    </>
  );
};

export default ManualFields;
